'use strict';

var define = require('define-properties');
var isSymbol = require('is-symbol');
var globalKey = '__ global cache key __';
/* istanbul ignore else */
// eslint-disable-next-line no-restricted-properties
if (typeof Symbol === 'function' && isSymbol(Symbol('foo')) && typeof Symbol['for'] === 'function') {
  // eslint-disable-next-line no-restricted-properties
  globalKey = Symbol['for'](globalKey);
}
var trueThunk = function () {
  return true;
};
var ensureCache = function ensureCache() {
  if (!global[globalKey]) {
    var properties = {};
    properties[globalKey] = {};
    var predicates = {};
    predicates[globalKey] = trueThunk;
    define(global, properties, predicates);
  }
  return global[globalKey];
};
var cache = ensureCache();
var isPrimitive = function isPrimitive(val) {
  return val === null || typeof val !== 'object' && typeof val !== 'function';
};
var getPrimitiveKey = function getPrimitiveKey(val) {
  if (isSymbol(val)) {
    return Symbol.prototype.valueOf.call(val);
  }
  return typeof val + ' | ' + String(val);
};
var requirePrimitiveKey = function requirePrimitiveKey(val) {
  if (!isPrimitive(val)) {
    throw new TypeError('key must not be an object');
  }
};
var globalCache = {
  clear: function clear() {
    delete global[globalKey];
    cache = ensureCache();
  },
  'delete': function deleteKey(key) {
    requirePrimitiveKey(key);
    delete cache[getPrimitiveKey(key)];
    return !globalCache.has(key);
  },
  get: function get(key) {
    requirePrimitiveKey(key);
    return cache[getPrimitiveKey(key)];
  },
  has: function has(key) {
    requirePrimitiveKey(key);
    return getPrimitiveKey(key) in cache;
  },
  set: function set(key, value) {
    requirePrimitiveKey(key);
    var primitiveKey = getPrimitiveKey(key);
    var props = {};
    props[primitiveKey] = value;
    var predicates = {};
    predicates[primitiveKey] = trueThunk;
    define(cache, props, predicates);
    return globalCache.has(key);
  },
  setIfMissingThenGet: function setIfMissingThenGet(key, valueThunk) {
    if (globalCache.has(key)) {
      return globalCache.get(key);
    }
    var item = valueThunk();
    globalCache.set(key, item);
    return item;
  }
};
module.exports = globalCache;